// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productDetailsSummaryStyles } from "@guestsupply/App/Components/ProductDetails/ProductDetailsSummary";
import { ellipsis } from "@guestsupply/XDL/Utilities";
import { css } from "styled-components";

productDetailsSummaryStyles.minQtyWrapper = {
    css: css`
        > div {
            justify-content: end;
        }
        &:empty {
            display: none;
        }
    `,
};
productDetailsSummaryStyles.itemReplacementsWrapper = {
    css: css`
        display: flex;
    `,
};
productDetailsSummaryStyles.container = {
    css: css`
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        padding: 20px 0;
        @media print {
            display: none;
        }
    `,
};
productDetailsSummaryStyles.leftSection = {
    css: css`
        display: flex;
        align-items: center;
        gap: 22px;
    `,
};
productDetailsSummaryStyles.rightSection = {
    css: css`
        display: flex;
        flex-direction: column;
        max-width: 320px;
    `,
};
productDetailsSummaryStyles.priceAndActionStyles = {
    productGridContainer: {
        price: {
            css: css`
                display: flex;
                flex-direction: column;
                align-items: end;
            `,
        },
    },
    productPriceStyles: {
        priceWrapper: {
            css: css`
                text-align: end;
            `,
        },
        price: {
            priceText: {
                size: 28,
                css: css`
                    line-height: 34px;
                `,
            },
            errorText: {
                css: css`
                    text-align: end;
                    font-size: 28px;
                    line-height: 34px;
                `,
            },
        },
    },
};
productDetailsSummaryStyles.productImageWrapper = {
    css: css`
        height: 91px;
        width: 91px;
    `,
};
productDetailsSummaryStyles.productImage = {
    css: css`
        max-width: 100%;
        max-height: 100%;
        img {
            max-height: 100%;
        }
    `,
};
productDetailsSummaryStyles.descriptionWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 8px;
        max-width: 543px;
    `,
};
productDetailsSummaryStyles.productTitle = {
    size: 14,
    weight: "bold",
    css: css`
        letter-spacing: 0;
        line-height: 16px;
        ${ellipsis(2)}
    `,
};
